import { gql } from "apollo-boost";

const channelInvitations = gql`
  query ($filter: ChannelInvitationFilter) {
    channelInvitations(filter: $filter) {
      total
      items {
        id
        name
        code
        notes
        createDate
        state
        invitedCount
        communityId
        community{
          id
          name
        }
      }
    }
  }
`;

export const saveChannelInvitation = gql`
  mutation saveChannelInvitation($input: SaveChannelInvitationInput!) {
    saveChannelInvitation(input: $input)
  }
`;

export const invitationGql = {
  channelInvitations,
  saveChannelInvitation,
};
